<template>
  <div class="wys_container">
    <img class="success_icon" src="../../images/coupon0507/succcess_icon.png" alt="" />
    <div class="yes">领取成功!</div>
    <div class="tip">优惠券已存入{{ userInfo.mobileNumber }}账号</div>
    <div class="tip">用户ID:{{ userInfo.userId }}</div>
    <div v-if="receiveInfo.isGoodsSale" @click="GoodJump" class="flexbox buy_btn_box">立即购买</div>
  </div>
</template>

<script>
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters('payment/coupons', ['receiveInfo'])
  },
  created() {
    this.userInfo = appUser
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('receiveInfo')
    next()
  },
  methods: {
    GoodJump() {
      if (this.receiveInfo.isGoodsSale) location.replace(this.receiveInfo.shareUrl)
    }
  }
}
</script>

<style lang="less" scoped>
.wys_container {
  padding-top: 1.4rem;
  text-align: center;
  .success_icon {
    display: block;
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto;
  }
  .yes {
    font-size: 0.36rem;
    font-weight: 600;
    color: #000000;
    margin: 0.3rem 0 1.4rem;
  }
  .tip {
    font-size: 0.3rem;
    color: #777777;
    margin-bottom: 5px;
  }
  .buy_btn_box {
    width: 2.16rem;
    height: 0.88rem;
    background: #00b25a;
    border-radius: 0.08rem;
    font-size: 0.32rem;
    font-weight: 500;
    color: #ffffff;
    justify-content: center;
    margin: 10vh auto 0;
  }
}
</style>
